import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"

interface Props {
  className?: string
}

export function RefreshIcon(props: Props) {
  const { _ } = useLingui()

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{_(msg`Refresh Icon`)}</title>
      <path
        d="M5.52007 5.69998V9.11998H8.94007"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M16.8061 8.88579L17.2145 9.51486L18.4726 8.69808L18.0642 8.06902L16.8061 8.88579ZM7.68005 7.17598L7.18005 6.61696L7.17833 6.61851L7.68005 7.17598ZM5.01833 8.56251C4.71044 8.8396 4.68549 9.31382 4.96258 9.6217C5.23967 9.92958 5.71389 9.95454 6.02177 9.67745L5.01833 8.56251ZM18.0642 8.06902C17.3045 6.89885 16.2225 5.97346 14.9487 5.40448L14.3369 6.77407C15.3465 7.225 16.204 7.9584 16.8061 8.88579L18.0642 8.06902ZM14.9487 5.40448C13.6748 4.8355 12.2636 4.64722 10.8851 4.86236L11.1164 6.34442C12.2089 6.17392 13.3274 6.32313 14.3369 6.77407L14.9487 5.40448ZM10.8851 4.86236C9.50669 5.0775 8.21992 5.68687 7.18005 6.61696L8.18005 7.735C9.00418 6.99787 10.024 6.51493 11.1164 6.34442L10.8851 4.86236ZM7.17833 6.61851L5.01833 8.56251L6.02177 9.67745L8.18177 7.73345L7.17833 6.61851Z"
        fill="currentColor"
      />
      <path
        d="M18.4801 18.3V14.88H15.0601"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M7.19405 15.1142L6.78566 14.4851L5.52754 15.3019L5.93593 15.9309L7.19405 15.1142ZM16.3201 16.824L16.8201 17.383L16.8218 17.3814L16.3201 16.824ZM18.9818 15.4374C19.2897 15.1604 19.3146 14.6861 19.0376 14.3783C18.7605 14.0704 18.2862 14.0454 17.9784 14.3225L18.9818 15.4374ZM5.93593 15.9309C6.6956 17.1011 7.77762 18.0265 9.05146 18.5955L9.6632 17.2259C8.65365 16.775 7.79612 16.0416 7.19405 15.1142L5.93593 15.9309ZM9.05146 18.5955C10.3253 19.1645 11.7365 19.3527 13.115 19.1376L12.8837 17.6555C11.7912 17.826 10.6728 17.6768 9.6632 17.2259L9.05146 18.5955ZM13.115 19.1376C14.4934 18.9224 15.7802 18.3131 16.8201 17.383L15.8201 16.265C14.996 17.0021 13.9762 17.485 12.8837 17.6555L13.115 19.1376ZM16.8218 17.3814L18.9818 15.4374L17.9784 14.3225L15.8184 16.2665L16.8218 17.3814Z"
        fill="currentColor"
      />
    </svg>
  )
}
